
$('.collections-list-menu li').hover(function(){
  console.log('hover');
  //$('.collections-list-menu li').removeClass('active');
  $(this).closest('.collections-list-menu').find('li').removeClass('active');  
  $(this).addClass('active');
  var dataCollection = $(this).attr('data-colname');
  console.log('dataCollection',dataCollection);
  //$('.collections-products-list .collection-products').css('display','none');
  $(this).closest('.custom-megamenu-container').find('.collection-products').css('display','none');
  //$('.collections-products-list .collection-products[data-colname="'+dataCollection+'"]').css('display','grid');
   $(this).closest('.custom-megamenu-container').find('.collection-products[data-colname="'+dataCollection+'"]').css('display','grid');
  
})

  $('.add-to-cart').click(function(){
      console.log('click');
    setTimeout(function() { 
         jQuery.getJSON('/cart.json', function(cart) {
          console.log(cart.item_count);
             $('.cart-link__bubble.cart-link__bubble--visible').text(cart.item_count);
          });
    }, 800);
  })



 // Function to set the width of .custom-menu-container
  function setContainerWidth() {
    const container = document.querySelectorAll('.custom-menu-container');
    const windowWidth = window.innerWidth;
    //console.log('windowWidth',windowWidth)
   // console.log('container-',container)
    // Set the width as a CSS property
    for (let i = 0; i < container.length; i++) {
       container[i].style.width = `${windowWidth}px`;
      //container.style.width = `${windowWidth}px !important`;
   }
    
  }

  // Call the function on page load and when the window is resized
  window.addEventListener('load', setContainerWidth);
  window.addEventListener('resize', setContainerWidth);

// Start - Size Guide chart
   // $('.size-guide-chart').click(function(){
     $( ".size-guide-chart" ).on( "click", function() {
        console.log('click');
        $('.size-guide-overlay').addClass('active-chart');
       $('body').addClass('popup-overflow');
     })  
     $('.size-guide-popup-close').on( "click", function() {
        console.log('close click');
        $('.size-guide-overlay').removeClass('active-chart');
       $('body').removeClass('popup-overflow');
     })
// End - Size Guide chart



 var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 1000);
  }
  ALAcheck();
  function customALA() {
     if($(".boost-sd__product-list").length > 0) {
      clearInterval(isALARendered);     
       console.log('collectiom')
          $( ".boost-sd__product-list .boost-sd__product-item" ).each(function( index ) {
            var tagName = $(this).find('.boost-sd__product-label--customLabelByTag .boost-sd__product-label-text').text();
            console.log('tagName',tagName);
            if (tagName == "14k"){
              $(this).find('.boost-sd__product-label--customLabelByTag ').addClass("14k")
            }else if(tagName == "10k"){
              $(this).find('.boost-sd__product-label--customLabelByTag ').addClass("10k")
            }
          });
      
    }  
  }



       


     